/**
 * Configuración central de la API
 * Cambia aquí la URL base del backend para todos los servicios
 */

// Debe coincidir con el puerto del backend (por defecto uvicorn en 8000).
// Opcional: crear frontend/.env con REACT_APP_API_URL=http://localhost:PUERTO
const API_BASE_URL = process.env.REACT_APP_API_URL !== undefined
  ? process.env.REACT_APP_API_URL
  : 'http://localhost:8000';

export default API_BASE_URL;




